import { Maybe, MaybeNull } from 'types';
import { DocumentMode } from 'types/Document';
import { RenvoiMode } from 'clients/documents/documentsClient.types';

export type SnackbarProps = {
	open: boolean;
	message: string;
	severity: 'info' | 'success' | 'error';
	autoHideDuration: number;
};

export type Mode = 'dark' | 'light';

export type DocumentTemplateSliceState = {
	showFilters: boolean;
	showDocumentSidebar: boolean;
	showFilesOverview: boolean;
	showRightContainer: boolean;
	faqOrNotesTab: FaqOrNotesTab;
};

export type DocumentModeSliceState = {
	mode: DocumentMode;
	draftPreviewMode: boolean;
	writeMode: boolean;
	readMode: boolean;
	reviewMode: boolean;
	showDraftVersion: boolean;
};

export type DocumentSearchSliceState = {
	renvoiMode: RenvoiMode;
	documentSearchResults: any;
	documentSearchHighlightedMap: any;
	documentSearchArticleResults: any;
	documentSearchHighlightedResults: any;
	documentSearchCurrentHighlightedId: string | undefined | null;
};

export interface HistoryBucket {
	title: number[];
	text_content: number[];
	json_content: number[];
}

export interface HistoryData {
	new_blocks: HistoryBucket;
	deleted_blocks: HistoryBucket;
	modified_blocks: HistoryBucket;

	new_articles: HistoryBucket;
	deleted_articles: HistoryBucket;
	modified_articles: HistoryBucket;

	new_sections: HistoryBucket;
	deleted_sections: HistoryBucket;
	modified_sections: HistoryBucket;
}

export type DocumentSliceState = {
	historyData: HistoryData;
};

export enum FaqOrNotesTab {
	FAQ = 'FAQ',
	NOTES = 'NOTES',
}

export type LayoutSliceState = {
	snackbarState: SnackbarProps;

	themeMode: Mode;
	isLightMode: boolean;
	sharedPopupOpen: boolean;
	showFAQ: boolean;
	layoutTempState: any;
	isMobile: boolean;

	documentMode: DocumentMode;
	showFilters: boolean;
	showDocumentSidebar: boolean;
};

export enum Dialog {
	InviteTeamMember = 'inviteTeamMember',
	QuestionAnswerDialog = 'questionAnswerDialog',
	PrintDocument = 'printDocument',
	NoteDialog = 'noteDialog',
	PublishDocument = 'PublishDocument',
}

export interface PublishDialogOptions extends DialogOptions {
	slug: string;
	currentPublicationDate?: string;
	onPublishSuccess?: () => void;
	publishData?: any;
}

export type DialogOptions = Maybe<any>;

export type ContextProps = {
	openDialog: (dialog: Dialog, options?: DialogOptions) => any;
	closeDialog: (dialog: Dialog) => any;
	asyncConfirmation: AsyncConfirmation;
	dialogOptions?: DialogOptions;
};

export type AsyncDialogProps = {
	show?: boolean;
	title?: MaybeNull<React.ReactNode>;
	content?: MaybeNull<React.ReactNode>;
	confirmLabel?: MaybeNull<React.ReactNode>;
	cancelLabel?: MaybeNull<React.ReactNode>;
};

export type AsyncConfirmation = (props: AsyncDialogProps) => Promise<boolean>;

export interface DocumentPrintSliceState {
	isPrintMode: boolean;
	isPrintPreview: boolean;
	itemsToPrint: Record<string, boolean>;
	shouldPrintAll: boolean;
}

export interface DocumentPublishSliceState {
	partialPublish: boolean;
	sectionsToPublish: number[];
	articlesToPublish: number[];
	blocksToPublish: number[];
}

export interface SectionSliceState {
	sectionId?: number;
	sectionTitle: string;
	setSectionId: (sectionId: number | undefined) => void;
	setSectionTitle: (sectionTitle: string) => void;
	setSection: (sectionId: number | undefined, sectionTitle: string) => void;
	resetSection: () => void;
}